import React from 'react';
import { FormFieldErrors } from 'src/components/shared/policy-metadata-form/hooks';
import ValidationErrors from '../../validation-errors/ValidationErrors';

const FORM_VALIDATION_ERRORS_CONFIG = [
  {
    id: 'policy-metadata-name',
    labelText: 'Policy Name',
    formFieldErrorKey: 'name',
  },
  {
    id: 'policy-metadata-description',
    labelText: 'Policy Description',
    formFieldErrorKey: 'description',
  },
  {
    id: 'policy-metadata-source-type-toggle-button',
    labelText: 'Source Type',
    formFieldErrorKey: 'sourceType',
  },
  {
    id: 'policy-metadata-link',
    labelText: 'Link',
    formFieldErrorKey: 'trackingSources',
  },
  {
    id: 'policy-metadata-domain-toggle-button',
    labelText: 'Domain',
    formFieldErrorKey: 'domain',
  },
  {
    id: 'policy-metadata-country-toggle-button',
    labelText: 'Country',
    formFieldErrorKey: 'country',
  },
  {
    id: 'policy-metadata-job-class-toggle-button',
    labelText: 'Job Class',
    formFieldErrorKey: 'jobClass',
  },
  {
    id: 'policy-metadata-states-toggle-button',
    labelText: 'States',
    formFieldErrorKey: 'states',
  },
];

interface ValidationErrorsProps {
  formFieldErrors: FormFieldErrors;
}

const RegisterPolicyValidationErrors = ({ formFieldErrors }: ValidationErrorsProps) => {
  return (
    <ValidationErrors
      errorConfigs={FORM_VALIDATION_ERRORS_CONFIG.map((config) => ({
        ...config,
        isError: formFieldErrors[config.formFieldErrorKey as keyof FormFieldErrors].isError,
      }))}
    />
  );
};

export default RegisterPolicyValidationErrors;
